import {TITLE_MASKED_FILTER_TYPES, MAIN_IMAGE_PREFIX, ICON_IMAGE_PREFIX, GREEN_ICON_IMAGE_PREFIX} from '../../../common/constants/constants';
import eventBus from '../../../common/event-bus/event-bus';
import createProductUrl from '../../../common/utils/create-product-url';

export default {
	props: {
		card: {
			type: Object,
			required: true
		},
		defaultImage: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			productUrl: createProductUrl(this.card.id),
			mainImage: this.card.imageInfo && this.card.imageInfo.image ? MAIN_IMAGE_PREFIX + this.card.imageInfo.image : this.defaultImage
		};
	},
	computed: {
		TITLE_MASKED_FILTER_TYPES() {
			return TITLE_MASKED_FILTER_TYPES;
		},

		leftBackgroundColor() {
			return this.card.imageInfo ? {background: this.card.imageInfo.leftSideColorCode} : '';
		},

		rightBackgroundColor() {
			return this.card.imageInfo ? {background: this.card.imageInfo.rightSideColorCode} : '';
		},

		optionals() {
			return this.card.green && this.card.green.length ? this.card.green.slice(0, 2) : null;
		}
	},
	methods: {
		addToCart() {
			eventBus.$emit('on-add-to-cart', this.card.id);
		},

		getIconUrl(filename) {
			return ICON_IMAGE_PREFIX + filename;
		},

		getGreenIconUrl(filename) {
			return GREEN_ICON_IMAGE_PREFIX + filename;
		},

		onMainImageError() {
			this.mainImage = this.defaultImage;
		}
	}

};



// WEBPACK FOOTER //
// ../source/modules/WSCD01-card-product-list/WSCD01-card-product/card-mixin.js